/* tslint:disable */
/* eslint-disable */
/**
 * SENGO Platform Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.27
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const EventStatus = {
    Ok: 'Ok',
    LimitedAvailability: 'LimitedAvailability',
    SoldOut: 'SoldOut',
    CancelledCreator: 'CancelledCreator',
    CancelledNoShow: 'CancelledNoShow',
    CancelledAdmin: 'CancelledAdmin',
    Concluded: 'Concluded',
} as const;

export type EventStatus = typeof EventStatus[keyof typeof EventStatus];



